export const LogoMark = ({ className = "w-10 h-10" }) => (
  <img src="/logo-mark.png" alt="JayPanduh" className={`${className} object-contain`} />
);

export const Logo = () => (
  <img src="/logo.png" alt="JayPanduh" data-testid="site-logo" className="h-11 md:h-14 w-auto object-contain" />
);
